import { ySyncPluginKey } from '@tiptap/y-tiptap';
export function isRemoteYjsTransaction(tr) {
    if (tr.getMeta('collaboration') || tr.getMeta('yjs')) {
        return true;
    }
    const ySyncMeta = tr.getMeta(ySyncPluginKey);
    if (ySyncMeta == null) {
        return false;
    }
    return (ySyncMeta.isChangeOrigin === true
        || ySyncMeta.snapshot != null
        || ySyncMeta.prevSnapshot != null);
}
//# sourceMappingURL=is-remote-yjs-transaction.js.map